import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { doctorEdit } from '../../../actions/doctorActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';

// components
import DoctorTooltipForm from './_DoctorTooltipForm';
import { Tooltip } from '../../shared/_tooltip';

class EditDoctorTooltip extends React.Component {
  static propTypes = {
    doctor:       PropTypes.instanceOf(Immutable.Map).isRequired,
    editDoctor:   PropTypes.func.isRequired,
    hideTooltip:  PropTypes.func.isRequired,
    showTooltip:  PropTypes.func.isRequired
  }

  render() {
    const { doctor } = this.props;

    return (
      <span>
        <i className='tooltip-button manager__doctor-index__edit-doctor-button manager__doctor-index__table__action fa fa-pencil-square-o'
          onClick={ this._handleShowEditDoctorTooltip } />

        <div className='tooltip-button-container'>
          <Tooltip className='manager__doctor-index__edit-doctor-tooltip'
            header='Edit Doctor'
            id={ this._getTooltipId() }>

            <DoctorTooltipForm doctorId={ doctor.get('id') } onClose={ this._handleHideTooltip } onSubmit={ this._handleEditDoctor } />
          </Tooltip>
        </div>
      </span>
    );
  }

  // private

  _handleEditDoctor             = this._handleEditDoctor.bind(this);
  _handleHideTooltip            = this._handleHideTooltip.bind(this);
  _handleShowEditDoctorTooltip  = this._handleShowEditDoctorTooltip.bind(this);

  _getTooltipId() {
    const { doctor } = this.props;

    return `editDoctorTooltip${doctor.get('id')}`;
  }

  _handleEditDoctor(attributes) {
    const { editDoctor } = this.props;
    const params = { ...attributes, tooltipId: this._getTooltipId() };

    editDoctor(params);
  }

  _handleHideTooltip() {
    const { hideTooltip } = this.props;

    hideTooltip(this._getTooltipId());
  }

  _handleShowEditDoctorTooltip() {
    const { showTooltip } = this.props;

    showTooltip(this._getTooltipId());
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    editDoctor: (params) => {
      dispatch(doctorEdit(params));
    },

    hideTooltip: (id) => {
      dispatch(tooltipHide({ id: id }));
    },

    showTooltip: (id) => {
      dispatch(tooltipShow({ id: id }));
    }
  };
};

export default connect(null, mapDispatchToProps)(EditDoctorTooltip);



// WEBPACK FOOTER //
// ./app/components/managers/doctors/_EditDoctorTooltip.jsx